/**
 * 3D Blocks Studio - Commerce & URL-sync
 * Extracted verbatim from gsd-3d-blocks-studio.js (file-size split):
 * standalone customize-link/product-url sync helpers plus a Vue mixin with
 * pricing computeds and cart/variant/URL methods.
 * Loaded after gsd-blocks-studio-utils.js and before gsd-3d-blocks-studio.js.
 */
window.sync3DCustomizeDesignLinks = function (studioUrl) {
  if (!studioUrl) return;
  var links = document.querySelectorAll("a");
  links.forEach(function (link) {
    var text = (link.textContent || "").trim().replace(/\s+/g, " ");
    var href = link.getAttribute("href") || "";
    var isCustomizeDesignLink =
      link.hasAttribute("data-3d-customize-design-link") ||
      ((text === "Customize This Design" ||
        text === "Customize in our Design Studio") &&
        href.indexOf("studiov2.feltright.com") !== -1);

    if (isCustomizeDesignLink) {
      link.href = studioUrl;
    }
  });
};

window.sync3DStudioDesignForProductUrl = function (productUrl) {
  var app = window.blocksStudio;
  if (!app || !productUrl) return false;

  var target;
  try {
    target = new URL(productUrl, window.location.origin).pathname;
  } catch (err) {
    return false;
  }

  var matchedSize = null;
  var sizeProducts = app.sizeProducts || {};
  Object.keys(sizeProducts).some(function (size) {
    var product = sizeProducts[size];
    if (!product || !product.url) return false;
    var path = new URL(product.url, window.location.origin).pathname;
    if (path === target) {
      matchedSize = size;
      return true;
    }
    return false;
  });

  if (!matchedSize) return false;

  var designPrefix = matchedSize === "Medium" ? "Middle" : matchedSize;
  var designIndex = (app.designs || []).findIndex(function (design) {
    return design.name && design.name.split(" ")[0] === designPrefix;
  });
  if (designIndex < 0 || designIndex === app.selectedDesignIndex) return false;

  var wasRestoring = app._restoring;
  app._restoring = true;
  app.selectedDesignIndex = designIndex;
  if (app.selectedSetIndex >= app.activeDesign.blockSets.length) {
    app.selectedSetIndex = 0;
  }
  app._restoring = wasRestoring;
  return true;
};

window.blocksStudioCommerceMixin = {
  computed: {
    unavailableSets: function () {
      var self = this;
      return this.activeDesign.blockSets.filter(function (set) {
        var variant = self.findVariant(set.buttonLabel, set.color, set.engraving);
        return !self.finishAllowed(set, set.color, set.engraving) || !variant || variant.available === false;
      });
    },
    canAddDesign: function () { return this.unavailableSets.length === 0; },
    designPrice: function () {
      var self = this,
        total = 0;
      this.activeDesign.blockSets.forEach(function (set) {
        var v = self.findVariant(set.buttonLabel, set.color, set.engraving);
        if (v && v.price) {
          var tilesPerSet = /^36 x 36/.test(set.buttonLabel) ? 2 : /^12 x 36/.test(set.buttonLabel) ? 4 : 8;
          total += v.price * Math.ceil(set.blocks.length / tilesPerSet);
        }
      });
      return total / 100;
    },
    saleActive: function () {
      return this.saleDiscountPercent > 0;
    },
    discountedDesignPrice: function () {
      if (!this.saleActive) return this.designPrice;
      return this.designPrice * (1 - this.saleDiscountPercent / 100);
    },
    totalPrice: function () {
      return (this.quantity * this.designPrice).toFixed(2);
    },
    discountedTotalPrice: function () {
      return (this.quantity * this.discountedDesignPrice).toFixed(2);
    },
    lineItems: function () {
      var q = this.quantity;
      var sizes = { "3,3": "Large", "1,3": "Medium", "1,1": "Small" };
      var items = this.activeDesign.blockSets.map(function (set) {
        var b = set.blocks[0],
          size = sizes[b.w + "," + b.h] || b.w + "x" + b.h;
        return {
          label: size + " " + set.depth + '" Acoustic Box - ' + set.color + (set.engraving && set.engraving !== 'None' ? ' — ' + set.engraving : ''),
          count: set.blocks.length * q,
          color: set.color,
        };
      });
      items.push(
        { label: 'Permanent 6" Tape Strips' },
        { label: "Drywall Screws" },
      );
      return items;
    },
    studioUrl: function () {
      var baseUrl = window.studioBaseUrl || "https://studiov2.feltright.com";
      var designId = this.activeDesign.customAppDesignId;
      if (!designId) return baseUrl;
      var params = new URLSearchParams({ import: designId });
      params.set("colors", this.activeDesign.blockSets.map(function (set) { return set.color; }).join(","));
      params.set("set_ids", this.activeDesign.blockSets.map(function (set) { return set.id; }).join(","));
      params.set("engravings", this.activeDesign.blockSets.map(function (set) { return set.engraving || "None"; }).join(","));
      return baseUrl + "?" + params.toString();
    },
  },
  methods: {
    updateUrl: function () {
      if (this._restoring) return;
      var self = this;
      clearTimeout(this._urlTimer);
      this._urlTimer = setTimeout(function () {
        var params = new URLSearchParams(window.location.search);
        var isDesignMode =
          window.__fr437ShopMode === "designs" ||
          params.get("shop_by") === "designs";
        if (!isDesignMode) {
          self.syncCustomizeDesignLinks();
          return;
        }
        params.set("shop_by", "designs");
        params.set("design", self.resolveActiveDesignProductHandle() || self.selectedDesignIndex);
        var colors = self.activeDesign.blockSets
          .map(function (s) {
            return s.color;
          })
          .join(",");
        params.set("colors", colors);
        var engravings = self.activeDesign.blockSets.map(function (set) { return set.engraving || "None"; });
        if (self.isCustomMode && engravings.some(function (value, i) { return value !== (self.activeDesign.presetEngravings || [])[i]; })) params.set("engravings", engravings.join(","));
        else params.delete("engravings");
        if (self.quantity > 1) params.set("qty", self.quantity);
        else params.delete("qty");
        var qs = params.toString();
        var url = window.location.pathname + (qs ? "?" + qs : "");
        history.replaceState({}, "", url);
        self.syncCustomizeDesignLinks();
      }, 150);
    },
    syncCustomizeDesignLinks: function () {
      if (window.sync3DCustomizeDesignLinks) {
        window.sync3DCustomizeDesignLinks(this.studioUrl);
      }
    },
    loadDesignProductMedia: function (product) {
      var self = this, ticket = (this._designMediaRequest || 0) + 1;
      this._designMediaRequest = ticket;
      document.querySelector('product-info:has([data-3d-shop-mode-root])')?.setAttribute('data-design-media-pending', '');
      return window.pdpFetchAndSwapMedia(product.firstVariantId, product.url, {
        skipBaseSetSupportingMedia: true, swapAll: true,
      }).then(async function (swapped) {
        if (ticket !== self._designMediaRequest || window.__fr437ShopMode !== "designs") return false;
        var section = document.querySelector('product-info:has([data-3d-shop-mode-root])');
        var image = section?.querySelector('[data-3d-hero-stage] img') || section?.querySelector('[data-pdp-gallery] .swiper-slide img');
        var ready = swapped === true && await window.PdpDesignLinks.waitImage(image);
        if (ticket !== self._designMediaRequest || window.__fr437ShopMode !== "designs") return false;
        window.PdpDesignLinks.finish(section, ready);
        self.updateUrl();
        self.syncCustomizeDesignLinks();
        // Once the shown design settles, prefetch the others for instant clicks.
        (window.requestIdleCallback || setTimeout)(function () { window.prefetchDesignSections?.(); });
        return ready;
      }).catch(function () {
        if (ticket === self._designMediaRequest && window.__fr437ShopMode === "designs")
          window.PdpDesignLinks.finish(document.querySelector('product-info:has([data-3d-shop-mode-root])'), false);
        return false;
      });
    },
    syncCurrentDesignMedia: function () {
      if (!this.activeDesign) return Promise.resolve(false);
      var product = this.resolveDesignProduct();
      if (product && product.url && window.pdpFetchAndSwapMedia) return this.loadDesignProductMedia(product);
      // No design product to wait for: reveal the page with its current media.
      window.PdpDesignLinks?.finish(document.querySelector('product-info:has([data-3d-shop-mode-root])'), true);
      this.syncOption1();
      return Promise.resolve(false);
    },
    resolveDesignProduct: function () {
      var handle = this.resolveActiveDesignProductHandle();
      var product = this.designProducts[handle];
      if (product && product.url) return product;
      var colorways = this.activeDesign.colorways || [];
      for (var i = 0; i < colorways.length; i++) {
        var cwHandle = colorways[i].shopifyProductHandle;
        if (
          cwHandle &&
          this.designProducts[cwHandle] &&
          this.designProducts[cwHandle].url
        ) {
          return this.designProducts[cwHandle];
        }
      }
      var baseHandle = this.activeDesign.shopifyProductHandle;
      if (
        baseHandle &&
        this.designProducts[baseHandle] &&
        this.designProducts[baseHandle].url
      ) {
        return this.designProducts[baseHandle];
      }
      return null;
    },
    resolveActiveDesignProductHandle: function () {
      if (!this.activeDesign) return null;
      var selectedColorway = this.activeDesign.selectedColorway;
      var match = /^preset-(\d+)$/.exec(selectedColorway || "");
      if (match && Array.isArray(this.activeDesign.colorways)) {
        var colorway = this.activeDesign.colorways[parseInt(match[1], 10)];
        if (colorway && colorway.shopifyProductHandle) {
          return colorway.shopifyProductHandle;
        }
      }
      return (
        this.activeDesign.shopifyProductHandle || this.activeDesign.customerName
      );
    },
    syncOption1: function () {
      var self = this;
      // Hide the old photo before the debounced selection lookup can paint.
      if (window.__fr437ShopMode === "designs" && self.activeDesign &&
          self.activeDesign.selectedColorway !== "custom" &&
          self.designProducts?.[self.resolveActiveDesignProductHandle()]?.url) {
        document.querySelector('product-info:has([data-3d-shop-mode-root])')?.setAttribute('data-design-media-pending', '');
        self._designMediaRequest = (self._designMediaRequest || 0) + 1;
      }
      clearTimeout(self._syncOption1Timer);
      self._syncOption1Timer = setTimeout(function () {
        self._syncOption1Now();
      }, 50);
    },
    _syncOption1Now: function () {
      var self = this;
      if (
        !this.activeDesign ||
        this.activeDesign.selectedColorway === "custom"
      ) {
        return;
      }
      // FR-459: Only sync design media when in designs mode. When the user is
      // in Set mode (Small/Medium/Large selector), syncOption1 is triggered
      // by the selectedDesignIndex watcher after sync3DStudioDesignForProductUrl
      // toggles _restoring synchronously — but Vue watchers fire on nextTick,
      // so the _restoring guard has already been reset to false by the time
      // this runs. Without this check, _syncOption1Now fires a second media
      // swap (swapAll: true) that replaces the size product's title, images,
      // and variant selectors with the design product (Causeway/Chord/Elevated).
      if (window.__fr437ShopMode && window.__fr437ShopMode !== "designs") {
        return;
      }
      var productHandle = this.resolveActiveDesignProductHandle();
      var product = this.designProducts[productHandle];
      if (product && product.url && window.pdpFetchAndSwapMedia) {
        return this.loadDesignProductMedia(product);
      }
      if (!window.pdpFetchAndSwap) return;
      var size = { Small: "Small", Middle: "Medium", Large: "Large" }[
        this.activeDesign.name.split(" ")[0]
      ];
      if (!size) return;
      var prod = this.sizeProducts[size];
      if (!prod || !prod.url) return;
      var variant = this.findVariant(
        this.activeBlockSet.buttonLabel,
        this.activeBlockSet.color,
      );
      window
        .pdpFetchAndSwap(variant ? variant.id : prod.firstVariantId, prod.url)
        .then(function () {
          self.updateUrl();
          self.syncCustomizeDesignLinks();
        });
    },
    findVariant: function (buttonLabel, colorName, engraving) {
      if (!buttonLabel || !colorName) return undefined;
      engraving = engraving || "None";
      var parts = buttonLabel
        .replace(" in", "")
        .split(" x ")
        .map(function (p) {
          return parseInt(p.trim(), 10);
        });
      if (parts.length !== 3) return null;
      var size;
      if (parts[0] === 36 && parts[1] === 36) size = "Large";
      else if (parts[0] === 12 && parts[1] === 36) size = "Medium";
      else if (parts[0] === 12 && parts[1] === 12) size = "Small";
      else return null;
      var depthOption = parts[2] + '"';
      // Studio finish names differ from Shopify's Color option labels.
      var colorAliases = { "natural walnut": "walnut", "medium elm": "elm" };
      var normalizedColor = colorName.toLowerCase();
      normalizedColor = colorAliases[normalizedColor] || normalizedColor;
      return this.productVariants.find(function (v) {
        var variantColor = v.option2.toLowerCase();
        return (
          v.size === size &&
          (v.engraving || "None") === engraving &&
          v.option1.indexOf(depthOption) === 0 &&
          (colorAliases[variantColor] || variantColor) === normalizedColor
        );
      });
    },
    addToCart: function () {
      var self = this;
      if (this.isAddingToCart || !this.canAddDesign) return;
      this.isAddingToCart = true;
      var designId = this.activeDesign.customAppDesignId;
      if (!designId) {
        alert("Design ID not configured. Please contact support.");
        this.isAddingToCart = false;
        return;
      }
      var colorsObj = {};
      this.activeDesign.blockSets.forEach(function (set, index) {
        colorsObj[index.toString()] = set.color;
      });
      window
        .blocksStudioAddToCart({
          designId: designId,
          colors: colorsObj,
          engravings: self.activeDesign.blockSets.map(function (set) { return set.engraving || "None"; }),
          setIds: self.activeDesign.blockSets.map(function (set) { return set.id; }),
          name:
            (self.activeDesign.customerName ||
              "Custom Design " + (self.selectedDesignIndex + 1)) + " - 3D",
          quantity: self.quantity,
          onPriceRetry: function () { self.retryMessage = "Preparing your design preview..."; },
          onRetry: function (attempt, max, delay) {
            self.retryMessage =
              "Server busy, retrying... (" + attempt + "/" + max + ")";
          },
        })
        .then(function () {
          self.retryMessage = "";
          if (self.bus && self.bus.$emit) {
            self.bus.$emit("showCart");
            self.bus.$emit("refreshCart");
          }
          self.isAddingToCart = false;
        })
        .catch(function (error) {
          self.retryMessage = "";
          self.isAddingToCart = false;
          console.error("3D Blocks Studio addToCart error:", error);
          Swal.fire({
            icon: "error",
            text: error.message || "Unable to add to cart. Please try again.",
          });
        });
    },
  },
};
